import { useEffect, useState } from 'react';
import { debounce } from '+/utils/debounce';

export const useWindowWidth = () => {
  const isClient = typeof window !== `undefined`;

  const getWidth = () => {
    return isClient ? window.innerWidth : undefined;
  };

  const [windowWidth, setWindowWidth] = useState(getWidth);

  useEffect(() => {
    if (!isClient) {
      return;
    }

    const debounceHandleResize = debounce(function handleResize() {
      setWindowWidth(window.innerWidth);
    }, 200);

    window.addEventListener('resize', debounceHandleResize);
    return () => {
      window.removeEventListener('resize', debounceHandleResize);
    };
  }, []);

  return { windowWidth };
};
